import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppBreadcrumbService } from '../../app.breadcrumb.service';

@Component({
  selector: 'app-datamining-detail',
  templateUrl: './datamining-detail.component.html',
  styleUrls: ['./datamining-detail.component.scss']
})
export class DataminingDetailComponent implements OnInit {
    transaction: any;
    transactionId: any;
    constructor(private activatedRoute: ActivatedRoute,
        private router: Router,
        private breadcrumbService: AppBreadcrumbService) { }

    ngOnInit(): void {
        var data = JSON.parse(this.activatedRoute.snapshot.data['transaction']);
        if (data != undefined && data.qdbapi != undefined) {
            this.transaction = data.qdbapi.field;
            this.transactionId = data.qdbapi.rid;
        }

        this.breadcrumbService.setItems([
            this.breadcrumbService.dataMining,
            { label: 'Transaction #' + this.transactionId, routerLink: [] }
        ]);       
    }

    formatValue(field) {
        var result = '';
        if (field.value.__cnt !== undefined)
            result = '';
        else {
            switch (field.fid) {
                //Modified this month
                case '44':
                    (field.value === 0) ? result = 'No' : result = 'Yes';
                    break;
                //Total Transaction or Service Value
                case '24':
                    result = '$' + Number(field.value).toLocaleString();
                    break;
                //managers
                case '51':
                    var emailarr = field.value.split(";");
                    if (emailarr === undefined) {
                        result = "";
                    }
                    else if (emailarr.length === 1) {
                        result = field.value;
                    }
                    else if (emailarr.length > 1) {
                        var namearr = field.printable.split(";");
                        for (var i = 0; i <= emailarr.length - 1; i++) {
                            result += namearr[i] + "(" + emailarr[i] + ");";
                        }
                    }

                    break;
                default:
                    result = field.value;
            }
        }
        return result;
    };

    navBack() {
        var url = "datamining-search";        
        this.router.navigate([url]);
    }

}
